import { CheckoutFormModel } from '../../model/checkout-forms.model';
import { CHECKOUT_FORM_PLACE_ORDER, CHECKOUT_FORM_UPDATE, UpdateCheckoutForm } from '../actions/checkout-forms.actions';
import { CheckoutFormsState } from '../checkout-forms.state';

export const initialState: CheckoutFormsState = {
  formsObjectValue: {},
};

export function reducer(state = initialState, action: UpdateCheckoutForm): CheckoutFormsState {
  switch (action.type as any) {
    case CHECKOUT_FORM_UPDATE: {
      const forms: CheckoutFormModel = action.payload.formsObjectValue;
      return { ...state, ...forms };
    }
    case CHECKOUT_FORM_PLACE_ORDER: {
      // const forms: CheckoutFormModel = action.payload.formsObjectValue;
      return { ...state };
    }
    default:
      return state;
  }
}
